export const faceNames = [
   "front",
   "back",
   "left",
   "right",
   "top",
   "bottom",
   "top_rear",
   "top_front",
   "bottom_rear",
   "bottom_front",
];
export const animNames = [
   "noAnim",
   "fadeInkf",
   "floatX",
   "floatShadow",
   "pulseSM",
   "pulseMD",
   "pulseLG",
   "swing",
   "swingDecay",
   "X360",
   "wobX",
   "fwdx018",
   "fwdx1836",
   "fwdx09",
   "fwdx918",
   "fwdx1827",
   "fwdx2736",
   "Y360",
   "wobY",
   "fwdy018",
   "fwdy1836",
   "fwdy09",
   "fwdy918",
   "fwdy1827",
   "fwdy2736",
];

export const animOptions = ["anim1", "anim2"];

export const animDirOptions = [
   "normal",
   "reverse",
   "alternate",
   "alternate-reverse",
];

export const animFillMode = ["none", "forwards", "backwards", "both"];

export const animPlayState = ["paused", "running", "initial", "inherit"];

export const animTiming = [
   "none",
   "ease-in",
   "ease-in-out",
   "linear",
   "step-start",
   "step-end",
   "cubic-bezier(0.1, 0.7, 1, 0.1)",
   "steps(4, end)",
   "steps(4, jump-start)",
   "steps(10, jump-end)",
   "steps(20, jump-none)",
   "steps(5, jump-both)",
   "steps(6, start)",
   "steps(8, end)",
];
export const perspectivesX = [
   "center",
   "left",
   "right",
   "0%",
   "25%",
   "50%",
   "75%",
   "100%",
   "150%",
   "175%",
   "200%",
   "250%",
   "500%",
   "-25%",
   "-50%",
   "-75%",
   "-100%",
   "-150%",
   "-175%",
   "-200%",
   "-250%",
   "-500%",
   "custom",
];
export const perspectivesY = [
   "center",
   "top",
   "bottom",
   "0%",
   "25%",
   "50%",
   "75%",
   "100%",
   "150%",
   "175%",
   "200%",
   "250%",
   "500%",
   "-25%",
   "-50%",
   "-75%",
   "-100%",
   "-150%",
   "-175%",
   "-200%",
   "-250%",
   "-500%",
   "custom",
];
